/* The Elysian — All Collections page
   Staggered card reveal only. Header / mobile nav / cart / search
   are already handled by the theme, so this file intentionally
   does nothing else. */
(function () {
  "use strict";

  function initReveal() {
    var grids = document.querySelectorAll(".ec-page .ec-grid");
    if (!grids.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var cards = entry.target.querySelectorAll(".ec-card");
            cards.forEach(function (card, i) {
              setTimeout(function () {
                card.classList.add("ec-reveal");
              }, i * 130);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    grids.forEach(function (grid) {
      observer.observe(grid);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }

  // Re-init if Shopify's theme editor re-renders a section (live preview)
  document.addEventListener("shopify:section:load", initReveal);
})();